import axios from "axios";

import {
  params,
  header,
  machineTypeAPI,
  customerTypeAPI,
  factoryTypeAPI,
  serialNumberTypeAPI,
} from "../_api";

import {
  FETCH_MACHINE_TYPES_SUCCESS,
  FETCH_MACHINE_TYPES_FAILURE,
  FETCH_CUSTOMER_TYPES_SUCCESS,
  FETCH_CUSTOMER_TYPES_FAILURE,
  FETCH_FACTORY_TYPES_SUCCESS,
  FETCH_FACTORY_TYPES_FAILURE,
  FETCH_SERIALNUMBER_TYPES_SUCCESS,
  FETCH_SERIALNUMBER_TYPES_FAILURE,
} from "../_constants";

const fetchMachineTypeSuccess = (data) => {
  return { type: FETCH_MACHINE_TYPES_SUCCESS, payload: data };
};

const fetchMachineTypeFailure = (error) => {
  return { type: FETCH_MACHINE_TYPES_FAILURE, payload: error };
};

export const fetchMachineType = () => {
  return async (dispatch) => {
    return axios({
      method: "get",
      url: machineTypeAPI,
      params: {
        ...params,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchMachineTypeSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchMachineTypeFailure(errorMsg));
      });
  };
};

const fetchCustomerTypeSuccess = (data) => {
  return { type: FETCH_CUSTOMER_TYPES_SUCCESS, payload: data };
};

const fetchCustomerTypeFailure = (error) => {
  return { type: FETCH_CUSTOMER_TYPES_FAILURE, payload: error };
};

export const fetchCustomerType = (machine_type, hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "get",
      url: customerTypeAPI,
      params: {
        ...params,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchCustomerTypeSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchCustomerTypeFailure(errorMsg));
      });
  };
};

const fetchFactoryTypeSuccess = (data) => {
  return { type: FETCH_FACTORY_TYPES_SUCCESS, payload: data };
};

const fetchFactoryTypeFailure = (error) => {
  return { type: FETCH_FACTORY_TYPES_FAILURE, payload: error };
};

export const fetchFactoryType = (customerType, machine_type, hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "get",
      url: factoryTypeAPI,
      params: {
        ...params,
        customer: customerType,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchFactoryTypeSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchFactoryTypeFailure(errorMsg));
      });
  };
};

const fetchSerialNumberTypeSuccess = (data) => {
  return { type: FETCH_SERIALNUMBER_TYPES_SUCCESS, payload: data };
};

const fetchSerialNumberTypeFailure = (error) => {
  return { type: FETCH_SERIALNUMBER_TYPES_SUCCESS, payload: error };
};

export const fetchSerialNumberType = (machine_type, hmi_type,customerType, factoryType) => {
  return async (dispatch) => {
    return axios({
      method: "get",
      url: serialNumberTypeAPI,
      params: {
        ...params,
        machine_type:machine_type,
        hmi_type:hmi_type,
        customer: customerType,
        plant: factoryType,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchSerialNumberTypeSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchSerialNumberTypeFailure(errorMsg));
      });
  };
};
